import { render, staticRenderFns } from "./settings-checkbox.vue?vue&type=template&id=0cc38575&scoped=true"
import script from "./settings-checkbox.vue?vue&type=script&lang=js"
export * from "./settings-checkbox.vue?vue&type=script&lang=js"
import style0 from "./settings-checkbox.vue?vue&type=style&index=0&id=0cc38575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc38575",
  null
  
)

export default component.exports